import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/** Placeholder Help screen — content can be expanded later. */
const Help = () => (
  <Box p={3}>
    <Paper sx={{ p: 3, maxWidth: 720 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <HelpOutlineIcon color="primary" />
        <Typography variant="h5" fontWeight={600}>
          Help
        </Typography>
      </Box>
      <Typography color="text.secondary">
        Help and documentation for AsroSync will appear here. Contact your administrator for support.
      </Typography>
    </Paper>
  </Box>
);

export default Help;
